import React from "react";
import ReactDOM from "react-dom/client";
import { Buffer } from "buffer";
import "@/index.css";
import App from "@/App";
import { AuthProvider, ChatProvider, UIProvider } from "@/contexts";
import { LanguageProvider } from "@/i18n";

// @solana/web3.js needs a global Buffer in the browser.
if (typeof window !== "undefined" && !window.Buffer) window.Buffer = Buffer;

// Service Worker Registration for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('Kaan AI: Service Worker kayıtlı', registration.scope);
      })
      .catch((error) => {
        console.log('Kaan AI: Service Worker kaydı başarısız', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <AuthProvider>
        <ChatProvider>
          <UIProvider>
            <App />
          </UIProvider>
        </ChatProvider>
      </AuthProvider>
    </LanguageProvider>
  </React.StrictMode>,
);
